// extracted by mini-css-extract-plugin
module.exports = {"container":"TabAccordion_container__15QpD","tagline":"TabAccordion_tagline__fXSlI","accordionContent":"TabAccordion_accordionContent__dveCA"};